import { capitalCase } from "change-case";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import {
  Box,
  Card,
  Stack,
  Link,
  Tooltip,
  Container,
  Typography,
  Button,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
// routes
import Iconify from "../../components/Iconify";
import { PATH_AUTH } from "../../routes/paths";
// hooks
import useAuth from "../../hooks/useAuth";
import useResponsive from "../../hooks/useResponsive";
// components
import Page from "../../components/Page";
import Logo from "../../components/Logo";
import Image from "../../components/Image";
// sections
import { LoginForm } from "../../sections/auth/login";
import cssStyles from "../../utils/cssStyles";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
  backgroundSize: "cover",
  backgroundImage: 'url("/static/assets/bg_card.png")',
  backgroundRepeat: "no-repeat",
  color: "white",
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuth();

  const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");

  const theme = useTheme();

  return (
    <Page title="Login">
      <RootStyle>
        <Box sx={{ width: '100%', ...cssStyles().bgBlur({ color: '#1E201E', blur: 1 }) }}>
          {/* <HeaderStyle>
          <Logo mini={mdUp} />
        </HeaderStyle> */}

          {/* {mdUp && (
          <SectionStyle>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Salut, bienvenue à nouveau
            </Typography>
            <Image
              visibleByDefault
              disabledEffect
              alt="login"
              src="/static/assets/illustrations/illustration_login.svg"
            />
          </SectionStyle>
        )} */}

          <Container maxWidth="sm">
            <ContentStyle>
              <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h4" gutterBottom>
                    Connectez-vous à bling
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    Entrez vos coordonnées ci-dessous.
                  </Typography>
                </Box>
              </Stack>

              <LoginForm />
            </ContentStyle>
          </Container>
          {/* <a
            href="https://wa.me/+56957540283"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant="contained"
              color="success"
              sx={{
                position: "fixed",
                bottom: 20,
                right: 20,
                borderRadius: "50%",
                width: 60,
                height: 60,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 3,
                "&:hover": {
                  boxShadow: 6,
                },
              }}
            >
              <Iconify icon="logos:whatsapp-icon" sx={{ fontSize: 30 }} />
            </Button>
          </a> */}
        </Box>
      </RootStyle>
    </Page>
  );
}
